import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';


import GlobalStorage from '../storage/GlobalStorage'
import AppZipCreator from'../../AppZipCreator'

import axios from 'axios'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.GS = new GlobalStorage();
    this.state = {
      
    }    
  }

  
  


  render()
  {
    return (
      <div>
        <ModalHeader toggle={()=>{this.props.toggleModal()}}>帳戶資料</ModalHeader>
        <ModalBody>
          <InputGroup>          
            <div class="input-group-prepend">
              <label class="input-group-text" for="displayName">用戶名</label>
            </div>
            <Input 
              id="displayName" 
              value={this.GS.getUser().reader.displayName}              
            />
          </InputGroup>
          <InputGroup>          
            <div class="input-group-prepend">
              <label class="input-group-text" for="gender">性別</label>
            </div>
            <Input id="gender" type="select" name="select" className="custom-select"   
              value={this.GS.getUser().reader.gender}
              onChange={(e) => {
                this.GS.getUser().reader.gender = e.target.value;
                this.forceUpdate();
              }}
            >
              <option value={'OTHER'}>{'未選擇'}</option>
              <option value={'MALE'}>{'男'}</option>
              <option value={'FEMALE'}>{'女'}</option>              
            </Input>
          </InputGroup>
          <InputGroup>          
            <div class="input-group-prepend">
              <label class="input-group-text" for="ageGroup">年齡</label>
            </div>
            
            <Input id="ageGroup" type="select" name="select" className="custom-select"   
              value={this.GS.getUser().reader.ageGroup}
              onChange={(e) => {
                this.GS.getUser().reader.ageGroup = e.target.value;
                this.forceUpdate();
              }}
            >
              <option value={'OTHER'}>{'未選擇'}</option>
              <option value={'TEENAGER'}>{'1 - 20'}</option>
              <option value={'TWENTIES'}>{'21 - 30'}</option>              
              <option value={'THIRTIES'}>{'31 - 40'}</option>              
              <option value={'FORTIES'}>{'41 - 50'}</option>              
              <option value={'FIFTIES'}>{'51 - 60'}</option>              
            </Input>
            
          </InputGroup> 
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={()=>{
            
    
            let api_url;                                
            api_url = global.API_URL+'readers/updateReader';
        
            
            //condition checking if any
            if (1){
              axios({
                method: 'patch',
                url: api_url,
                data:{displayName:document.getElementById("displayName").value,
                      gender:document.getElementById("gender").value,
                      ageGroup:document.getElementById("ageGroup").value},
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: this.GS.getUser().token,
                }
              })
              .then(response => {
                alert("已更新!");              
              })
              .catch(error => {
                    
              });              
            }else{
              //alert("請輸入有效電郵！");              
            }
          }}>提交</Button>{' '}              
        </ModalFooter>
      </div>
    )
  }
}